import { useMediaQuery } from '@mui/material';
import { createContext, useContext } from 'react';
import { DummyComponent } from 'cliengo-types/types/global';

import { NavBar } from './NavBar';

import { TopBar } from '@/components/NewNavigation/TopBar';

const navigationContext = createContext<{
  isSmall: boolean;
}>({
  isSmall: false,
});

const NavigationProvider = ({ children }: DummyComponent) => {
  const isSmall = useMediaQuery('(max-width:800px)');

  return (
    <navigationContext.Provider value={{ isSmall }}>
      {children}
    </navigationContext.Provider>
  );
};

export const useNavigationContext = () => useContext(navigationContext);

export const Navigation = () => {
  return (
    <NavigationProvider>
      <>
        <TopBar />
        <NavBar />
      </>
    </NavigationProvider>
  );
};
